export const UserFlightBookingData = [
  {
    key: "1",
    id: "#FB-1245",
    flightname: "Antonov An-32",
    flightimage:"assets/img/flight/flight-09.jpg",
    flighttype:"Air India",
    ticketname: "Business Class",
    members: "2 Adults,1 Child",
    from_to: "London - Paris",
    price: "$11,569",
    Date: "15 May 2025",
    status: "Upcoming",
    action:"upcoming",
  },
  {
    key: "2",
    id: "#FB-3215",
    flightname: "SkyBound 102",
    flightimage:"assets/img/flight/flight-08.jpg",
    flighttype:"London",
    ticketname: "Economy",
    members: "2 Adults,2 Child",
    from_to: "Los Angeles - Tokyo",
    price: "$10,745",
    Date: "20 May 2025",
    status: "Upcoming",
    action:"upcoming",
  },
  {
    key: "3",
    id: "#FB-4581",
    flightname: "Nimbus 345",
    flightimage:"assets/img/flight/flight-06.jpg",
    flighttype:"Edinburgh",
    ticketname: "Fare Economy",
    members: "3 Adults, 2 Child",
    from_to: "London - Dubai",
    price: "$8,160",
    Date: "04 Jun 2025",
    status: "Upcoming",
    action:"upcoming",
  },
  {
    key: "4",
    id: "#FB-6545",
    flightname: "AstraFlight 215",
    flightimage:"assets/img/flight/flight-01.jpg",
    flighttype:"Manchester",
    ticketname: "Suite",
    members: "2 Adults, 1 Child",
    from_to: "Atlanta - Barcelona",
    price: "$14,840",
    Date: "17 Jun 2025",
    status: "Pending",
    action:"pending",
  },
  {
    key: "5",
    id: "#FB-3256",
    flightname: "Cloudrider 789",
    flightimage:"assets/img/flight/flight-02.jpg",
    flighttype:"Chelsea",
    ticketname: "Economy",
    members: "1 Adult, 1 Child",
    from_to: "Chicago - Frankfurt",
    price: "$10,450",
    Date: "25 Jun 2025",
    status: "Upcoming",
    action:"upcoming",
  },
  {
    key: "6",
    id: "#FB-3654",
    flightname: "Aether Express 901",
    flightimage:"assets/img/flight/flight-03.jpg",
    flighttype:"Las Vegas",
    ticketname: "First Class",
    members: "2 Adults, 2 Child",
    from_to: "Miami - Madrid",
    price: "$12,600",
    Date: "02 Jul 2025",
    status: "Cancelled",
    action:"cancelled",
  },
  {
    key: "7",
    id: "#FB-1458",
    flightname: "Voyager 658",
    flightimage:"assets/img/flight/flight-07.jpg",
    flighttype:"Salford",
    ticketname: "Economy",
    members: "2 Adults, 3 Child",
    from_to: "Toronto - Rome",
    price: "$9,380",
    Date: "12 Jul 2025",
    status: "Completed",
    action:"completed",
  },
  {
    key: "8",
    id: "#FB-6589",
    flightname: "Delta D118",
    flightimage:"assets/img/flight/flight-01.jpg",
    flighttype:"Newyork",
    ticketname: "Fare Economy",
    members: "2 Adults, 2 Child",
    from_to: "Boston - Amsterdam",
    price: "$10,400",
    Date: "26 Jul 2025",
    status: "Completed",
    action:"completed",
  },
  {
    key: "9",
    id: "#FB-2315",
    flightname: "Silverwing 505",
    flightimage:"assets/img/flight/flight-04.jpg",
    flighttype:"Cambridge",
    ticketname: "Business Class",
    members: "1 Adult, 1 Child",
    from_to: "Dallas - London",
    price: "$12,810",
    Date: "10 Aug 2025",
    status: "Completed",
    action:"completed",
  },
  {
    key: "10",
    id: "#FB-5414",
    flightname: "Altair 333",
    flightimage:"assets/img/flight/flight-05.jpg",
    flighttype:"Bristol",
    ticketname: "Business Class",
    members: "2 Adults, 2 Child",
    from_to: "Seattle - Seoul",
    price: "$15,450",
    Date: "22 Aug 2025",
    status: "Completed",
    action:"completed",
  },

];
